import { Fragment } from "react";
import ReactMarkdown from "react-markdown";
import { HELP_GUIDES } from "./content";
import { GuideArticle } from "./guide-article";
import { GuideBefore } from "./guide-before";
import { GuideChecks } from "./guide-checks";
import { GuideStep } from "./guide-step";
import { PayrollEditExample } from "./payroll-edit-example";
import { PayrollRerunExample } from "./payroll-rerun-example";

const guide = HELP_GUIDES["payroll/runs/edits"];
const stepIds = ["choose-edit", "check-edit", "cell-comments", "rerun-edit"];

export const PayrollEditsGuide = () => (
  <GuideArticle previewId="payroll-edit-example" lead={guide.intro}>
    <GuideBefore>
      <p>{guide.before}</p>
    </GuideBefore>
    {guide.sections.map((section, index) => (
      <GuideStep
        key={stepIds[index]}
        id={stepIds[index]}
        step={index + 1}
        title={section.title}
      >
        {section.body.split("\n\n").map((paragraph, paragraphIndex) => (
          <Fragment key={paragraph}>
            <ReactMarkdown>{paragraph}</ReactMarkdown>
            {index === 1 && paragraphIndex === 0 && <PayrollEditExample />}
          </Fragment>
        ))}
        {index === 3 && <PayrollRerunExample />}
      </GuideStep>
    ))}
    <GuideChecks checks={guide.checks} problem={guide.problem} />
  </GuideArticle>
);
